import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack
} from "./HelpDialogLayout";

export interface MorningLightDialogProps extends HelpDialogLayoutProps {
}
export default function MorningLightDialog(props: MorningLightDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <BodyTypographies
            contents={[
              "人間の体内時計は24時間より少し長い周期で動いており、地球の24時間サイクルと合わせるためにリセットが必要です。また日常生活の様々な要因により、少しずつずれていってしまいます。体内時計のずれを放置すると、倦怠感が抜けず、最終的には心身の疾患に結び付いてしまうリスクが強く指摘されています。これを避けるためには、朝の太陽光を浴びることがこのリセットに最も効果的であり、結果的に夜のスムーズな入眠を助けます。",
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">おすすめ</Typography>
          <BodyTypographies
            contents={[
              "起床後は太陽の光を浴びましょう。",
              "外に出て浴びることが望ましいですが、難しければ窓際でカーテンを開けるだけでも十分効果的です。",
              "より具体的には、2,500ルクス以上の光で体内時計はリセットされますが、晴れた日の太陽光は100,000ルクス、曇りの日でも10,000ルクスあります。窓越しの日光浴だと曇りの日で2,500ルクス程度なので、少なくともカーテンを開けて光を浴びることが必要になります。逆に、室内の蛍光灯は明るく感じますが、実は通常のオフィスで500ルクス程度しかなく、住宅の室内はさらに暗くなるので体内時計のリセットには不十分となります。",
            ]}
          />
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
